import { Component } from '@angular/core';
import { CustomTabItem, TabAction } from '../../../shared-components/custom-tabs/custom-tabs.component';

@Component({
	selector: 'app-custom-tabs-showcase',
	templateUrl: './custom-tabs-showcase.component.html',
	styleUrls: ['./custom-tabs-showcase.component.scss'],
	standalone: false,
})
export class CustomTabsShowcaseComponent {
	public basicActiveId: string = 'overview';
	public iconsActiveId: string = 'overview';
	public conditionalActiveId: string = 'overview';
	public overflowActiveId: string = 'tab-1';
	public actionsActiveId: string = 'overview';
	public legacyActiveId: string = 'overview';
	public lastAction: string = 'No action yet';
	public showAdvancedTab: boolean = true;

	public readonly basicTabs: CustomTabItem[] = [
		{ id: 'overview', label: 'Overview' },
		{ id: 'details', label: 'Details' },
		{ id: 'history', label: 'History' },
	];

	public readonly iconTabs: CustomTabItem[] = [
		{ id: 'overview', label: 'Overview', icon: 'fa-house' },
		{ id: 'details', label: 'Details', icon: 'fa-circle-info' },
		{ id: 'history', label: 'History', icon: 'fa-clock-rotate-left' },
		{ id: 'settings', label: 'Settings', icon: 'fa-gear' },
	];

	public readonly overflowTabs: CustomTabItem[] = Array.from({ length: 20 }, (_, index) => ({
		id: `tab-${index + 1}`,
		label: `Long tab label ${index + 1}`,
		icon: 'fa-folder',
	}));

	public get conditionalTabs(): CustomTabItem[] {
		return [
			{ id: 'overview', label: 'Overview', icon: 'fa-house' },
			{ id: 'details', label: 'Details', icon: 'fa-circle-info' },
			{ id: 'advanced', label: 'Advanced', icon: 'fa-wrench', condition: this.showAdvancedTab },
		];
	}

	public readonly actions: TabAction[] = [
		{ type: 'button', text: 'Create', preIcon: 'fa-solid fa-plus', action: () => (this.lastAction = 'Create clicked') },
		{ type: 'button', text: 'Export', preIcon: 'fa-solid fa-download', variant: 'outlined', action: () => (this.lastAction = 'Export clicked') },
		{
			type: 'menu',
			text: 'More',
			variant: 'outlined',
			menuItems: [
				{ text: 'Duplicate', action: () => (this.lastAction = 'Duplicate clicked') },
				{ text: 'Archive', action: () => (this.lastAction = 'Archive clicked') },
				{ text: 'Delete', action: () => (this.lastAction = 'Delete clicked') },
			],
		},
		{ type: 'button', text: 'Hidden action', condition: false },
	];

	public onTabChange(target: 'basic' | 'icons' | 'conditional' | 'overflow' | 'actions' | 'legacy', tabId: string): void {
		this[`${target}ActiveId`] = tabId;
	}

	public toggleAdvancedTab(): void {
		this.showAdvancedTab = !this.showAdvancedTab;
		if (!this.showAdvancedTab && this.conditionalActiveId === 'advanced') {
			this.conditionalActiveId = 'overview';
		}
	}

	public onLegacyAction(): void {
		this.lastAction = 'Legacy projected action clicked';
	}
}
